





















































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import Icon from "@/components/BrandIcon.vue";
import BrandIcon from "@/components/BrandIcon.vue";
import FraudCaseDetails from "@/components/FraudCaseDetails.vue";
import {TransactionFilter} from "@/model/transaction-filter";
import {TransactionPreview} from "@/model/transaction-preview";
import {transactionService} from "@/services/transaction";

@Component({
  components: {FraudCaseDetails, BrandIcon, Icon}
})
export default class TransactionsTable extends Vue {

  @Prop()
  transactionFilter?: TransactionFilter

  @Prop()
  transactions?: TransactionPreview[]

  loading = true

  optionsDialog = false

  selected: TransactionPreview[] = []

  headers: any[] = [...this.defaultHeaders]
  allHeaders: any[] = [...this.defaultHeaders,...this.extraHeaders]

  async mounted() {
    this.onTransactionFilterChange();
    this.loading = false;
  }

  @Watch('transactionFilter',{
    deep: true
  })
  async onTransactionFilterChange() {
    if(this.transactionFilter) {
      this.transactions = await transactionService.getAllTransactions(this.transactionFilter);
    }
  }

  @Watch('transactions')
  onTransactionsChange() {
    const msisdns = [...new Set(this.transactions?.map(t => t.msisdn))]
    const colorMap: any = {}

    msisdns.forEach((number,index) => {
      colorMap[number] = this.selectColor(index)
    })

    this.transactions?.forEach(t => t.color = colorMap[t.msisdn])

    this.$emit('caseIds',[...new Set(this.transactions?.flatMap(t => t.fraudCaseTransactionList).map(f => f.fraudCaseId))]);
  }

  selectColor(number: number) {
    const hue = number * 137.508; // use golden angle approximation
    return `hsl(${hue},50%,75%)`;
  }

  get defaultHeaders() {
    return [
      {
        text: 'Id',
        value: 'id',
      },
      {
        text: 'Date',
        value: 'receiptDateEst',
        sort: (a: any, b: any) =>  a-b
      },
      {
        text: 'Tech',
        value: 'technology',
        width: '5px'
      },
      {
        text: 'Amount (w/o Tax)',
        value: 'amount'
      },
      {
        text: 'Origin',
        value: 'countryCodeFrom'
      },
      {
        text: 'Destination',
        value: 'countryCodeTo'
      },
      {
        text: 'Msisdn',
        value: 'msisdn'
      },
      {
        text: 'User',
        value: 'userInfo'
      },
      {
        text: 'Product',
        value: 'productType'
      },
      {
        text: 'Status',
        value: 'paymentState'
      },
      {
        text: 'Result',
        value: 'txResult'
      },
      {
        text: 'Method',
        value: 'authorizeMethod'
      },
      {
        text: 'Link',
        value: 'link'
      }
    ];
  }

  get extraHeaders() {
    return [
      {
        text: 'Credit Card Token',
        value: 'creditCardToken',
      },
      {
        text: 'Paypal Payer Id',
        value: 'paypalPayerId',
      },
      {
        text: 'AVS',
        value: 'avsMessage',
      },
      {
        text: 'Bank Response',
        value: 'bankResponse',
      },
      {
        text: 'Balance',
        value: 'balance',
      },
      {
        text: 'Error message',
        value: 'errorMessage',
      },
      {
        text: 'IP',
        value: 'ipAddress'
      }
    ]
  }
}
